
/* eslint-disable @typescript-eslint/camelcase */
import {
  ErrorMessageEntities,
  ModalMessageEntities,
  OptionsClass
} from "@/domain/entities/MainApp";
import {
  PusatResolusiV2CodeResponseCreate,
  PusatResolusiV2Action,
  CategoryPusatResolusi,
  PusatResolusiSTT
} from "@/domain/entities/PusatResolusiV2";
import { Vue, Options } from "vue-class-component";
import {
  PusatResolusiV2Detail,
  PusatResolusiV2Type,
  TicketPusatResolusiDetail
} from "@/domain/entities/PusatResolusiV2";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import {
  CheckTicketPusatResolusiRequest,
  CheckCategoryPusatResolusiRequest
} from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import HowToReportCard from "./how-to-report-card.vue";
import cardSTT from "./cardSTT.vue";
import {
  INTERNET_ERROR,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import CsInfo from "./cs-info.vue";
import _ from "lodash";
import { FlagsPermissionPusatResolusiV2 } from "@/feature-flags/flags-pusat-resolusi-v2";
import GenericInfobar from "./infobar.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";

@Options({
  components: {
    HowToReportCard,
    cardSTT,
    CsInfo,
    GenericInfobar
  }
})
export default class PusatResolusiV2Create extends Vue {
  // initial data
  onBack(isFromModal = false) {
    this.$router.push(
      isFromModal ? "/pusat-resolusi-v2/tiket-saya" : "/pusat-resolusi-v2"
    );
    this.form = new PusatResolusiV2Detail();
    this.ticketDetail = new TicketPusatResolusiDetail();
    this.sttShipmentDetail = [];
    this.sttShipmentResponse = [];
    this.sttIssueCategory = "";
    this.listCategory = [];
    this.sttOrShipmentNoInLastSttOrShipmentList = false;
    this.onResetAllAttachments();
    this.showResponseCreate = false;
    this.categoryCode = "";
  }

  get getPusatResolusiV2Action() {
    return PusatResolusiV2Action;
  }
  get getPusatResolusiV2Type() {
    return PusatResolusiV2Type;
  }
  get acceptContentFlag() {
    return FlagsPermissionPusatResolusiV2.config_accept_attachment_extension.getValue();
  }
  form = new PusatResolusiV2Detail();
  get typeList(): OptionsClass[] {
    return [
      new OptionsClass({
        name: this.$t('pusatResolusi.create.pengirimanNbantuan'),
        value: PusatResolusiV2Type.shippingService
      }),
      new OptionsClass({
        name: this.$t('pusatResolusi.create.sistemNbandingPinalti'),
        value: PusatResolusiV2Type.systemPenalty
      })
    ]
  };

  mounted() {
    this.form.sttNoShipmentNo = (this.$route.query.sttNo as string) || "";
  }

  // type
  onChangeType(item: OptionsClass) {
    if (this.form.type !== item.value) {
      this.form = new PusatResolusiV2Detail({
        type: item.value
      });
      this.sttShipmentDetail = [];
      this.sttShipmentResponse = [];
      this.onResetAllAttachments();
      this.sttOrShipmentNoInLastSttOrShipmentList = false;
      this.categoryCode = "";
    }
  }

  // stt or shipment
  isTooltipCheck = false;
  toggleTooltipCheck(event: any) {
    this.isTooltipCheck = !this.isTooltipCheck;

    const refs: any = this.$refs;
    refs?.["opTooltip"]?.toggle(event);
  }
  sttOrShipmentNoInLastSttOrShipmentList = false;
  isChangeSttOrShipmentNo = false;
  onChangeSttNoShipmentNo() {
    this.isChangeSttOrShipmentNo = true;
    this.sttShipmentDetail = [];
    this.sttShipmentResponse = [];
    this.sttIssueCategory = "";
    this.listCategory = [];
    this.categoryCode = "";
    this.form = new PusatResolusiV2Detail({
      ...this.form,
      sttNoShipmentNo: this.form.sttNoShipmentNo,
      category: new OptionsClass()
    });

    const alreadyInList = !!PusatResolusiV2Controller.lastSttOrShipmentNoList.find(
      (e) => e.sttNo?.toLowerCase() === this.form.sttNoShipmentNo?.toLowerCase()
    );
    if (alreadyInList) {
      this.sttOrShipmentNoInLastSttOrShipmentList = true;
      return;
    }

    if (!this.form.sttNoShipmentNo) {
      this.sttOrShipmentNoInLastSttOrShipmentList = false;
      return;
    }
  }
  async onSelectStt(item: PusatResolusiSTT) {
    this.form = new PusatResolusiV2Detail({
      ...this.form,
      sttNoShipmentNo: item.sttNo
    });

    this.isChangeSttOrShipmentNo = true;
    await this.onCheckStt();
  }
  sttShipmentDetail: TicketPusatResolusiDetail[] = [];
  sttIssueCategory = "";
  categoryCode = "";
  excludeStatus = ["CLOSED", "PAID", "REJECT", "RECONCILE"];
  isScanByTicketNo = false;
  sttShipmentResponse: TicketPusatResolusiDetail[] = [];

  async onCheckStt(isCheckButton = false) {
    const invalidStt =
      (!this.isChangeSttOrShipmentNo && !isCheckButton) ||
      !this.form.sttNoShipmentNo;
    if (invalidStt) return;

    const checkTicket = async () => {
      try {
        MainAppController.showLoading();
        const resp = await PusatResolusiV2Controller.checkTicketV2(
          new CheckTicketPusatResolusiRequest({
            refNo: this.form.sttNoShipmentNo
          })
        );
        this.sttShipmentResponse = resp;
        this.sttShipmentDetail = resp.filter(
          (item) =>
            !this.excludeStatus.includes(item.status) && item.status !== ""
        );
        if (this.isChangeSttOrShipmentNo) {
          this.form = new PusatResolusiV2Detail({
            type: this.form.type,
            sttNoShipmentNo: this.form.sttNoShipmentNo
          });
          this.onResetAllAttachments();
        }

        // hide card last stt or shipment no if stt or shipment is valid
        this.sttOrShipmentNoInLastSttOrShipmentList = true;
        this.isScanByTicketNo = /^[0-9]+$/.test(
          this.form.sttNoShipmentNo.trim()
        );
        if (!this.listCategory.length) await this.fetchListCategory();
        if (this.categoryCode !== "" && isCheckButton) {
          this.checkCategoryTicket(
            new OptionsClass({ meta: { code: this.categoryCode } })
          );
        }
      } catch (error) {
        this.onErrorCheckStt(error);
      } finally {
        MainAppController.closeLoading();
        this.isChangeSttOrShipmentNo = false;
      }
    };

    if (isCheckButton) {
      const checkTicketDebounced = _.debounce(checkTicket, 200);
      checkTicketDebounced();
    } else if (this.form.sttNoShipmentNo.length >= 3) {
      await checkTicket();
    } else {
      this.sttShipmentDetail = [];
      this.sttShipmentResponse = [];
    }
  }
  onErrorCheckStt(error: any) {
    const message = error?.response?.data?.message?.id;

    if (message) {
      this.sttShipmentDetail = [
        new TicketPusatResolusiDetail({
          message
        })
      ];
      return;
    }

    MainAppController.showErrorMessage(
      parsingErrorResponse(error, this.$t('pusatResolusi.create.failedCheck'))
    );
  }

  toDetail(id: number) {
    this.$router.push(`/pusat-resolusi-v2/detail/${id}`);
  }

  // category
  listCategory: OptionsClass[] = [];
  async getListCategory(open = false) {
    if (open) {
      await this.onCheckStt();
      if (this.errorMessageTicket) return;
      await this.fetchListCategory();
    }
  }

  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign
  }

  async fetchListCategory() {
    try {
      MainAppController.showLoading();
      this.listCategory = [];
      const { sttNoShipmentNo, type } = this.form;
      const res = await PusatResolusiV2Controller.getListCategory(
        new CheckTicketPusatResolusiRequest({
          refNo: !this.errorMessageTicket ? sttNoShipmentNo : "",
          type,
          isEn: this.isAccountForeign
        })
      );
      this.onSuccessGetListCategory(res);
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, this.$t('pusatResolusi.create.faieldCheckCategory'))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
  onSuccessGetListCategory(res: CategoryPusatResolusi[]) {
    const listCaseType = this.sttShipmentDetail
      .flatMap((item) => item.caseType)
      .filter(Boolean);
    // sort by disabled
    const data = res.map(
      (item) =>
        new OptionsClass({
          name: item.label,
          value: item.code,
          disabled: listCaseType.includes(item.caseType),
          chipLabel: this.mapCaseTypeLabel(item.caseType?.replace("Case ", "")),
          chipStyle: this.mapBackgroundStyle(
            item.caseType?.replace("Case ", "")
          ),
          meta: {
            ...item
          }
        })
    );
    this.listCategory = data.sort((a, b) => {
      if (a.disabled === b.disabled) return 0;
      if (a.disabled && !b.disabled) return 1;
      return -1;
    });
  }
  async checkCategoryTicket(itemCategory: OptionsClass) {
    this.sttIssueCategory = "";
    MainAppController.showLoading();
    try {
      await PusatResolusiV2Controller.checkCategory(
        new CheckCategoryPusatResolusiRequest({
          sttNo: this.form.sttNoShipmentNo,
          code: itemCategory.meta?.code
        })
      );
    } catch (error) {
      this.onErrorCheckCategory(error);
    } finally {
      MainAppController.closeLoading();
    }
  }
  onErrorCheckCategory(error: any) {
    const message = error?.response?.data?.message;
    this.sttIssueCategory = this.isAccountForeign ? message?.en : message?.id;
  }
  onSelectCategory(item: OptionsClass) {
    this.sttIssueCategory = "";
    this.form = new PusatResolusiV2Detail({
      ...this.form,
      description: item.meta?.template || "",
      isDescRequired: !!item.meta?.isDescRequired,
      isAttachmentRequired: !!item.meta?.isAttachmentRequired
    });
    this.categoryCode = item.meta?.code;
    this.checkCategoryTicket(item);
  }

  // description
  onDeleteDescription() {
    this.form.description = "";
  }

  // attachment
  onAddFile() {
    this.form.attachments.push(null);
  }
  onResetAllAttachments() {
    this.form.attachments.forEach((_, index) => {
      const file = this.$refs?.[`attachment-${index}`] as any;
      file?.onReset?.();
    });
    // Reset the attachments array to initial state with one null value
    this.form.attachments = [null];
  }

  // pre submit
  get disabled(): boolean {
    const {
      type,
      sttNoShipmentNo,
      category,
      description,
      isDescRequired,
      attachments,
      isAttachmentRequired
    } = this.form;

    return [
      this.sttIssueCategory,
      this.errorMessageTicket, // error stt or shipment no,
      this.prohibitedDuplicate,
      !type || !category?.value, // type or category not selected
      type === PusatResolusiV2Type.shippingService && !sttNoShipmentNo, // stt or shipment required for shipping service
      isDescRequired && !description, // description required based on category
      isAttachmentRequired && attachments?.some((a) => !a) // attachment required based on category
    ].some((a) => a);
  }
  onConfirmCreate() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: "badge-confirmation-general",
        title: this.$t('pusatResolusi.create.isReportDone'),
        message: this.$t('pusatResolusi.create.confirmMessage'),
        onSubmit: this.onCreate,
        onClose: () => {
          MainAppController.closeMessageModal();
        },
        textSuccess: this.$t('pusatResolusi.create.yes'),
        textCancel: this.$t('pusatResolusi.create.cancel'),
        customWidth: "417px",
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6"
      })
    );
  }

  // submit
  showResponseCreate = false;
  ticketDetail = new TicketPusatResolusiDetail();
  async onCreate() {
    try {
      MainAppController.showLoading();
      MainAppController.closeMessageModal();

      this.ticketDetail = await PusatResolusiV2Controller.create(
        new CheckTicketPusatResolusiRequest({
          categoryCode: this.form.category?.value,
          refNo: this.form.sttNoShipmentNo,
          desc: this.form.description,
          attachments: this.form.attachments.filter(
            (e): e is File => e instanceof File
          )
        })
      );
      this.showResponseCreate = true;
    } catch (error) {
      const data: any = (error as any)?.response?.data;

      if (!(error as any).response) {
        MainAppController.showErrorMessage(
          new ErrorMessageEntities({
            type: INTERNET_ERROR,
            title: this.$t('pusatResolusi.emptyInternet'),
            message: this.$t('pusatResolusi.history.internetErrorDesc'),
            onClose: () => this.onCreate(),
            buttonSuccessText: this.$t('pusatResolusi.history.reload')
          })
        );
        MainAppController.setErrorMessageEntities({
          ...MainAppController.errorMessageEntities,
          title: this.$t('pusatResolusi.emptyInternet'),
          message: this.$t('pusatResolusi.history.internetErrorDesc')
        });
        return;
      }
      if (
        !PusatResolusiV2CodeResponseCreate[
          data?.code as keyof typeof PusatResolusiV2CodeResponseCreate
        ]
      ) {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, this.$t('pusatResolusi.create.failed'))
        );
        return;
      }

      this.onFailedCreate(data);
    } finally {
      MainAppController.closeLoading();
    }
  }
  onFailedCreate(data: any) {
    const { code, ticket, stt, shipment } = data;

    // for code 101 and 102
    if (ticket) {
      this.ticketDetail = new TicketPusatResolusiDetail({
        id: ticket.id,
        ticketNo: ticket.ticket_no,
        caseNumber: ticket.case_number,
        refNo: ticket.ref_no,
        categoryCode: ticket.category_code,
        categoryName: ticket.category.label,
        desc: ticket.desc,
        status: ticket.status,
        shipmentId: shipment.shipment_id,
        shipmentLastStatus: shipment.last_status,
        sttNo: stt.stt_no,
        sttLastStatus: stt.last_status,
        action: ticket.category?.action,
        code
      });
    } else {
      // for code 103
      this.ticketDetail = new TicketPusatResolusiDetail({
        shipmentId: shipment.shipment_id,
        shipmentLastStatus: shipment.last_status,
        sttNo: stt.stt_no,
        sttLastStatus: stt.last_status,
        code
      });
    }
    this.showResponseCreate = true;
  }
  get responseCreateData(): ModalMessageEntities {
    const onClose = () => {
      this.showResponseCreate = false;
      this.ticketDetail = new TicketPusatResolusiDetail();
    };
    const data = new ModalMessageEntities({
      title: this.ticketDetail.success
        ? this.$t('pusatResolusi.create.success')
        : this.$t('pusatResolusi.create.fail'),
      image: this.ticketDetail.success
        ? "Ill_Badge_Action-Success"
        : "stop-program",
      onSubmit: () => this.onBack(true),
      onClose
    });

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["101"]) {
      return new ModalMessageEntities({
        ...data,
        message: this.$t('pusatResolusi.create.everReported'),
        textSuccess: this.$t('pusatResolusi.create.seeDetail'),
        onSubmit: () => this.toDetail(this.ticketDetail.id),
        textCancel: this.$t('pusatResolusi.create.back')
      });
    }

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["102"]) {
      return new ModalMessageEntities({
        ...data,
        title: this.$t('pusatResolusi.create.problemHavBeenReported'),
        message: ""
      });
    }

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["103"]) {
      return new ModalMessageEntities({
        ...data,
        message: this.$t('pusatResolusi.create.lastStatusMessage'),
        textSuccess: this.$t('Cek Kembali'),
        onSubmit: () => {
          onClose();
          this.sttIssueCategory = this.$t('pusatResolusi.create.sttIssueCategory');
        }
      });
    }

    if (this.ticketDetail.code === PusatResolusiV2CodeResponseCreate["104"]) {
      return new ModalMessageEntities({
        ...data,
        title: this.$t('pusatResolusi.create.ticketDetail'),
        message: ""
      });
    }

    return new ModalMessageEntities({
      ...data,
      message: this.$t('pusatResolusi.create.teamWillProcess'),
      textSuccess: this.$t('pusatResolusi.success.ok')
    });
  }
  get showCsInfoCreateResponse() {
    const codeType =
      this.ticketDetail.code === PusatResolusiV2CodeResponseCreate[102] ||
      this.ticketDetail.code === PusatResolusiV2CodeResponseCreate[104];

    return codeType && !this.ticketDetail.success;
  }
  get pusatResolusiV2CodeResponseCreate() {
    return PusatResolusiV2CodeResponseCreate;
  }

  onDeleteAttachment(index: number) {
    this.form.attachments.splice(index, 1);
  }

  formatRefNumber(value: string) {
    return value.toUpperCase().replace(/\s+/g, "");
  }

  get showListDuplicate() {
    return this.sttShipmentDetail.length && !this.errorMessageTicket;
  }

  get prohibitedDuplicate() {
    if (!this.showListDuplicate) return false;
    return this.isScanByTicketNo || this.listCategory.every((o) => o.disabled);
  }

  get actionItems() {
    return this.showListDuplicate
      ? this.sttShipmentDetail.map((item: TicketPusatResolusiDetail) => ({
          id: item.id,
          caseTypeLabel: item.caseType?.replace("Case ", ""),
          caseNumber: item.caseNumber,
          categoryName: item.categoryName,
          statusLabel: item.statusData?.label
        }))
      : [];
  }

  get errorMessageTicket() {
    return this.sttShipmentDetail.length
      ? this.sttShipmentDetail[0].message
      : "";
  }

  mapCaseTypeLabel(caseTypeLabel: string) {
    const caseType: any = {
      "non operation": "Non operation"
    };

    return caseType[caseTypeLabel?.toLowerCase()] ?? caseTypeLabel;
  }

  mapBackgroundStyle(item: string) {
    const caseType: any = {
      operation: "bg-red-lp-750"
    };

    return caseType[item?.toLowerCase()] ?? "bg-blue-lp-800";
  }
}
